<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="选择课件"
    width="80%"
    top="5vh"
    @close="handleClose"
  >
    <div style="padding: 16px 16px 0">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-card>
            <dic-tree
              v-if="visible"
              v-model="listQuery.params.catId"
              dic-code="course_file_catalog"
              @backFunc="searchRightList"
            />
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-input
            @keyup.enter.native="searchRightList"
            v-model="listQuery.params.title"
            style="width: 200px"
            placeholder="搜索课件名称"
            class="filter-item"
            size="small"
          />
          <dic-list-select
            v-model="listQuery.params.fileType"
            dic-code="course_file_type"
            class="filter-item ml10"
            @backFunc="searchRightList"
          />
          <el-button
            :disabled="selectList.length === 0"
            type="primary"
            size="small"
            class="filter-item ml10"
            @click="handleConfirm"
            >{{ selectedLabel }}</el-button
          >

          <el-button
            icon="el-icon-search"
            type="primary"
            @click="getRightList"
            size="small"
            class="ml10"
            >搜索</el-button
          >

          <el-table
            ref="tableRef"
            class="m-small-table mt10"
            v-loading="listLoading"
            :key="tableKey"
            :data="rightList"
            border
            fit
            highlight-current-row
            @select="tableSelectChange"
            @select-all="tableSelectAll"
            @row-click="tableRowClick"
          >
            <!-- 多选 -->
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column label="课件名称" align="center" prop="title" />

            <el-table-column label="课件大小" align="center" prop="fileSize" />

            <el-table-column
              label="课件时长"
              align="center"
              show-overflow-tooltip
            >
              <template v-slot="scope">
                <span v-if="scope.row.duration === 0">无</span>
                <span v-else>
                  <sec-format :value="scope.row.duration" />
                </span>
              </template>
            </el-table-column>

            <el-table-column
              label="课件类型"
              align="center"
              prop="fileType_dictText"
            />
          </el-table>
          <pagination
            class="mt10"
            :total="rightTotal"
            :page.sync="listQuery.current"
            :limit.sync="listQuery.size"
            @pagination="getRightList"
          />
          <div class="clear"></div>
        </el-col>
      </el-row>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" icon="el-icon-back">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { postAction } from "@/api";
export default {
  name: "CourseFileDialog",
  props: {
    excludes: Array,
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedLabel: "请勾选课件",

      listQuery: {
        current: 1,
        size: 10,
        params: {
          excludes: [],
          title: "",
          fileType: ""
        }
      },
      rightList: [],
      rightTotal: 0,

      // 选定的数据列表
      selectList: [],

      options: {
        // 可批量操作
        multi: true,
        multiShow: false,
        // 列表请求URL
        listUrl: "/api/learn/api/course/file/paging"
      }
    };
  },

  watch: {
    // 检测查询变化
    visible: {
      handler() {
        this.dialogVisible = this.visible;

        if (this.dialogVisible) {
          this.listQuery = {
            current: 1,
            size: 10,
            params: {
              excludes: [],
              title: "",
              fileType: "",
              catId: '',
            }
          };
          this.searchRightList();
          this.$refs.tableRef.clearSelection();
        }
        // if (this.dialogVisible && this.$refs.pagingTable !== undefined) {
        //   this.getRightList()
        //   // this.$refs.pagingTable.getList();
        // }
      },
      deep: true
    },

    excludes: {
      handler() {
        this.listQuery.params.excludes = this.excludes;
      },
      deep: true
    },

    selectList: {
      handler(val) {
        if (val.length > 0) {
          this.selectedLabel = "确认" + val.length + "项";
        } else {
          this.selectedLabel = "请勾选课件";
        }
      },
      deep: true
    },

    "listQuery.params.catId": {
      handler(val) {
        if (val) {
        }
      }
    }
  },

  created() {
    this.dialogVisible = this.visible;
  },

  methods: {
    searchRightList() {
      this.listQuery.current = 1;
      this.getRightList();
    },

    getRightList() {
      postAction("/learn/api/course/file/paging", this.listQuery).then(res0 => {
        console.log("res0", res0);

        let res = res0.data;
        this.rightList = res.data.records;
        this.rightTotal = res.data.total;

        let list = this.rightList;
        this.$nextTick(() => {
          if (this.selectList.length > 0) {
            for (let item of list) {
              let isHas = this.selectList.some(row => row.id == item.id);
              if (isHas) {
                this.$refs.tableRef.toggleRowSelection(item, true);
              } else {
                this.$refs.tableRef.toggleRowSelection(item, false);
              }
            }
          } else {
            this.$refs.tableRef.clearSelection();
          }
        });
      });
    },

    tableSelectChange(arr, row) {
      this.tableCheckBaseFunc(row);
    },
    tableRowClick(row, column, event) {},
    tableCheckBaseFunc(row) {
      let isCheck = !this.selectList.some(item => item.id == row.id);
      console.log("isCheck", isCheck);
      if (isCheck) {
        this.selectList.push(row);
      } else {
        let selectList = this.selectList.filter(item => {
          return item.id != row.id;
        });
        this.selectList = JSON.parse(JSON.stringify(selectList));
      }
    },
    tableSelectAll(arr) {
      let len = arr.length;

      let list = JSON.parse(JSON.stringify(this.rightList));
      let selectList = JSON.parse(JSON.stringify(this.selectList));
      if (len == 0) {
        let newList = [];
        for (let item of selectList) {
          let hasId = list.some(item2 => item2.id == item.id);
          if (!hasId) {
            newList.push(item);
          }
        }
        selectList = JSON.parse(JSON.stringify(newList));
      } else {
        for (let item of list) {
          let hasId = selectList.some(item2 => item2.id == item.id);
          if (!hasId) {
            selectList.push(item);
          }
        }
      }
      this.selectList = selectList;
    },
    ////////
    // 选定回调
    handleSelected(obj) {
      console.log("回调了吗", obj);
      this.selectList = obj.objs;
    },

    // 关闭回调
    handleClose() {
      this.$emit("update:visible", false);
    },

    // 确认选定
    handleConfirm() {
      this.$emit("select", JSON.parse(JSON.stringify(this.selectList)));
      this.selectList = [];
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
::v-deep .el-dialog__body {
  padding: 0px;
}
</style>
